export default {
  makes: state => state.makes
}



// WEBPACK FOOTER //
// ./src/store/modules/make/getters.js